import React, { FC, ReactNode, useContext } from 'react';
import { Icon }                             from 'semantic-ui-react';
import { Cell, Grid }                       from "styled-css-grid";
import _                                    from 'underscore';

import { Size }                                     from '@src/types';
import { LangService, ProjectService, TimeService } from '@src/services';
import { ENTITY_COLORIZATION }                      from '@src/constants';
import { StyledContainer }                          from '@src/views/containers';
import { MilestoneDateIcon }                        from '@src/views/components/project/MilestoneDateIcon';
import { CustomStartDateIcon }                      from '@src/views/components/project/CustomStartDateIcon';
import { DashboardProjectListItemContext }          from './ProjectListItem';
import { usePrefStates, useProject }                from "@src/hooks";


interface DetailFieldObject {
    label: string,
    value: string,
    icon?: ReactNode | null
}

interface Props {}

const defaultProps: Props = {}

const ProjectListItemDetails: FC<Props> = ( props ) => {

    let { project }                              = useContext( DashboardProjectListItemContext ),
        { getMaybeCurrentProjectVersionFromSet } = useProject( project.id ),
        [ , prefs, prefEnums ]                   = usePrefStates( project.id );

    let termDictionary = LangService.getDictionary( project.termDictionary ),
        dictionaryHash = {
            assetNameLabel:          LangService.getTermFromDictionary( 'PROJECT_DETAILS.ASSET_NAME.LABEL', termDictionary ),
            assetIndicationLabel:    LangService.getTermFromDictionary( 'PROJECT_DETAILS.ASSET_INDICATION.LABEL', termDictionary ),
            customStartDateUtcLabel: LangService.getTermFromDictionary( 'PROJECT_DETAILS.CUSTOM_START_DATE.LABEL', termDictionary ),
            customStartDateUtcDesc:  LangService.getTermFromDictionary( 'PROJECT_DETAILS.CUSTOM_START_DATE.DESCRIPTION', termDictionary ),
            launchDateUtcLabel:      LangService.getTermFromDictionary( 'PROJECT_MILESTONES.LAUNCHDATE.LABEL', termDictionary ),
            launchDateUtcDesc:       LangService.getTermFromDictionary( 'PROJECT_MILESTONES.LAUNCHDATE.DESCRIPTION', termDictionary ),
        };

    if( !project.isCorvalManaged ){

        const currentProjectVersion = getMaybeCurrentProjectVersionFromSet( project.projectVersions );

        if( currentProjectVersion ){

            project.launchDateUtc = currentProjectVersion.launchDateUtc;
        }
    }

    let detailFields: DetailFieldObject[] = _.compact( [
        {
            label: dictionaryHash.assetNameLabel,
            value: project.assetName,
            icon:  <Icon name={ 'cube' } color={ 'teal' } fitted/>
        },
        {
            label: dictionaryHash.assetIndicationLabel,
            value: project.assetIndication,
            icon:  <Icon name={ 'cube' } color={ 'teal' } fitted/>
        },

        project.customStartDateUtc ?
        {
            label: dictionaryHash.customStartDateUtcLabel,
            value: TimeService.ISOtoDisplayDate( project.customStartDateUtc ),
            icon:  <CustomStartDateIcon date={ TimeService.ISOtoMoment( project.customStartDateUtc ) }/>
        } : null,

        project.launchDateUtc ?
        {
            label: dictionaryHash.launchDateUtcLabel,
            value: TimeService.ISOtoDisplayDate( project.launchDateUtc ),
            icon:  <MilestoneDateIcon
                       label={ dictionaryHash.launchDateUtcLabel }
                       desc={ dictionaryHash.launchDateUtcDesc }
                       date={ TimeService.ISOtoMoment( project.launchDateUtc ) }
                       icon={ { fitted: true, color: ENTITY_COLORIZATION.MILESTONES.LAUNCHDATE } }
                   />
        } : null,
    ] );

    return (

        <StyledContainer padding={ [ Size.SM, null ] }>

            <Grid columns={ `auto minmax(auto, 200px) 1fr` } rowGap={ `` }>

                { detailFields.map( ( detail, index ) => (

                    <React.Fragment key={ index }>
                        <Cell center>{ detail.icon ?? null }</Cell>
                        <Cell><strong>{ detail.label }:</strong></Cell>
                        <Cell>{ detail.value }</Cell>
                    </React.Fragment>

                ) ) }
            </Grid>

        </StyledContainer>
    );
};

ProjectListItemDetails.defaultProps = defaultProps;

export { ProjectListItemDetails }
